const NUMBERED_NAME = /^(session\s+\d+)\s*[:\-–—]\s*(.+)$/i;

/**
 * "Session 35: Straight Leg Frogger" → { number: 'Session 35', title: 'Straight Leg Frogger' }.
 * Names without the numbered prefix come back whole as the title.
 * @param {string | undefined} name
 * @returns {{ number: string | null, title: string }}
 */
const splitSessionName = (name = '') => {
  const match = name.trim().match(NUMBERED_NAME);
  if (!match) return { number: null, title: name.trim() };
  return { number: match[1].replace(/\s+/, ' '), title: match[2].trim() };
};

export default splitSessionName;
